'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type ReactNode, useRef, useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { SilkSheet } from '@/components/ui/silk-sheet';
import { TOAST_IDS } from '@/config/toast-ids';
import { logger } from '@/lib/telemetry/logger';
import { showToast } from '@/lib/ui/toast';
export function FundingDisconnect(t0) {
  const $ = _c(51);
  const {
    canDisconnect,
    busy,
    onDisconnect
  } = t0;
  const t = useTranslations("onramp");
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);
  const submitting = useRef(false);
  const blocked = busy || pending;
  let t1;
  if ($[0] !== busy) {
    t1 = function changeOpen(next) {
      if (!submitting.current && !busy) {
        setOpen(next);
      }
    };
    $[0] = busy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const changeOpen = t1;
  let t2;
  if ($[2] !== busy || $[3] !== canDisconnect || $[4] !== onDisconnect || $[5] !== t) {
    t2 = async function confirm() {
      if (submitting.current || busy || !canDisconnect) {
        return;
      }
      submitting.current = true;
      setPending(true);
      const disconnected = await disconnect(onDisconnect).finally(() => {
        submitting.current = false;
        setPending(false);
      });
      if (disconnected) {
        setOpen(false);
      } else {
        showToast({
          id: TOAST_IDS.ONRAMP_DISCONNECT,
          message: t("profile_disconnect_failed"),
          variant: "error"
        });
      }
    };
    $[2] = busy;
    $[3] = canDisconnect;
    $[4] = onDisconnect;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const confirm = t2;
  const t3 = !canDisconnect || blocked;
  let t4;
  if ($[7] !== changeOpen) {
    t4 = () => changeOpen(true);
    $[7] = changeOpen;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("profile_disconnect");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <AnimatedButton variant="outline" disabled={t3} onClick={t4}>{t5}</AnimatedButton>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("profile_disconnect_title");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("profile_disconnect_body");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <p className="text-body text-foreground-secondary">{t8}</p>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = blocked || !canDisconnect;
  let t11;
  if ($[21] !== confirm) {
    t11 = () => {
      confirm();
    };
    $[21] = confirm;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("profile_disconnect");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== pending || $[26] !== t10 || $[27] !== t11 || $[28] !== t12) {
    t13 = <AnimatedButton variant="destructive" loading={pending} disabled={t10} onClick={t11}>{t12}</AnimatedButton>;
    $[25] = pending;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== changeOpen) {
    t14 = () => changeOpen(false);
    $[30] = changeOpen;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t("profile_disconnect_cancel");
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== blocked || $[35] !== t14 || $[36] !== t15) {
    t16 = <AnimatedButton variant="tertiary" disabled={blocked} onClick={t14}>{t15}</AnimatedButton>;
    $[34] = blocked;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t13 || $[39] !== t16 || $[40] !== t9) {
    t17 = <div className="flex flex-col gap-4">{t9}{t13}{t16}</div>;
    $[38] = t13;
    $[39] = t16;
    $[40] = t9;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== blocked || $[43] !== changeOpen || $[44] !== open || $[45] !== t17 || $[46] !== t7) {
    t18 = <SilkSheet open={open} onOpenChange={changeOpen} title={t7} guardDismiss={blocked} size="sm">{t17}</SilkSheet>;
    $[42] = blocked;
    $[43] = changeOpen;
    $[44] = open;
    $[45] = t17;
    $[46] = t7;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t18 || $[49] !== t6) {
    t19 = <>{t6}{t18}</>;
    $[48] = t18;
    $[49] = t6;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  return t19;
}
async function disconnect(onDisconnect: () => Promise<boolean>): Promise<boolean> {
  try {
    return await onDisconnect();
  } catch {
    logger.warn('onramp.disconnect_failed');
    return false;
  }
}